import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { View } from 'foundations-components/components/View';
import { PageSection } from 'pricing-pages-ui-components/semantic/PageSection';
import { NavItemEnum } from '../../constants/routing/NavItems';
import { useAppSelector } from '../../reducers';
import { ownedHubSpotCreditsTotalSelector } from '../../selectors/ProductInventorySelectors';
import { bundledProductLinesForSkuIdSelector, highestProductLevelFromSkuIdsSelector, productForSkuIdSelector, skuIdHasBundledProductsSelector } from '../../selectors/ProductsSelectors';
import { navItemForProductLineSelector } from '../../selectors/RoutingSelectors';
import HubSpotCreditsFeatures from '../key-features/HubSpotCreditsFeatures';
import BillingNameTitle from './BillingNameTitle';
import UnlockAIHeader from './UnlockAIHeader';
import { HubSpotCreditsTilesContainerInbound25 } from '../merch-card/hubspot-credits/HubSpotCreditsTilesContainerInbound25';
import { useSortedProductInventory } from '../../hooks/useSortedProductInventory';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const UnlockAIContent = () => {
  var _sortedProductInvento;
  const sortedProductInventory = useSortedProductInventory();
  const skuIds = sortedProductInventory.map(product => product.currentVersion.skuId);
  const highestProductLevel = useAppSelector(state => highestProductLevelFromSkuIdsSelector(state, {
    skuIds
  }));
  const ownsAdditionalCredits = useAppSelector(state => {
    const ownedQuantity = ownedHubSpotCreditsTotalSelector(state);
    return ownedQuantity && ownedQuantity > 0;
  });
  const skuId = (_sortedProductInvento = sortedProductInventory[0]) === null || _sortedProductInvento === void 0 ? void 0 : _sortedProductInvento.currentVersion.skuId;
  const subscreen = useAppSelector(state => {
    const isBundle = skuIdHasBundledProductsSelector(state, {
      skuId
    });
    if (isBundle) {
      return bundledProductLinesForSkuIdSelector(state, {
        skuId
      }).map(productLine => {
        return navItemForProductLineSelector(state, productLine);
      });
    }
    const productLine = productForSkuIdSelector(state, {
      skuId
    }).productLine;
    if (!productLine) {
      return NavItemEnum.SUITE;
    }
    return navItemForProductLineSelector(state, productLine);
  });
  return /*#__PURE__*/_jsx(PageSection, {
    children: /*#__PURE__*/_jsxs(View, {
      backgroundColor: "fill-surface-default",
      padding: "1300",
      children: [/*#__PURE__*/_jsx(UnlockAIHeader, {
        title: /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "pricingPage.pages.hubspot-credits.unlockAI.title",
          options: {
            billingName: highestProductLevel === 'STARTER' ? /*#__PURE__*/_jsx(BillingNameTitle, {
              bilingNameKey: "crm-suite-starter-bundle"
            }) : /*#__PURE__*/_jsx(BillingNameTitle, {
              skuId: skuId
            })
          }
        })
      }), ownsAdditionalCredits ? null : /*#__PURE__*/_jsx(HubSpotCreditsTilesContainerInbound25, {
        screen: NavItemEnum.HUBSPOT_CREDITS,
        unlockHubSpotCreditsSkuIds: []
      }), /*#__PURE__*/_jsx(HubSpotCreditsFeatures, {
        subscreen: subscreen
      })]
    })
  });
};
export default UnlockAIContent;